import { Badge } from "@/components/ui/badge";
import { MapPin, Building2, Phone, ArrowRight } from "lucide-react";

const ServiceAreasSection = () => {
  return (
    <section className="py-20 bg-amber-50" data-testid="service-areas-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <Badge className="bg-amber-100 text-amber-700 mb-4">Service Areas</Badge>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-testid="service-areas-title">
            Serving Surat & All Over India
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Based in Surat, we provide comprehensive HVAC services locally. For large-scale Ductable and VRF projects, we serve clients across India.
          </p>
        </div>

        {/* Google Map - Centered */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3720.0134!2d72.8311!3d21.1959!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04e59411d1563%3A0x3e5bb8b3fe0d5f78!2sNanpura%2C%20Surat%2C%20Gujarat%20395001!5e0!3m2!1sen!2sin!4v1704067200000!5m2!1sen!2sin"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="MARCO AIR CONDITION Location"
              className="w-full"
            ></iframe>
          </div>
          
          {/* Location Info Below Map */}
          <div className="mt-4 bg-white rounded-xl p-6 shadow-lg flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <div className="bg-amber-500 p-3 rounded-lg">
                <MapPin className="h-6 w-6 text-white" />
              </div>
              <div>
                <h4 className="font-bold text-gray-900 text-lg">MARCO AIR CONDITION</h4>
                <p className="text-gray-600">Ground Floor, Prasanna Chambers, Makkaipool Nanpura Circle, Nanpura, Surat - 395001</p>
              </div>
            </div>
            <a
              href="https://www.google.com/maps/dir/?api=1&destination=Prasanna+Chambers+Nanpura+Surat+395001"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-500 to-yellow-500 hover:from-amber-600 hover:to-yellow-600 text-black font-semibold px-6 py-3 rounded-lg transition-all whitespace-nowrap"
            >
              <MapPin className="h-5 w-5" />
              Get Directions
              <ArrowRight className="h-5 w-5" />
            </a>
          </div>
        </div>

        {/* Service Area Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          <div className="bg-white rounded-xl p-6 shadow-md border border-amber-100">
            <div className="flex items-start gap-4">
              <div className="bg-amber-100 p-3 rounded-lg">
                <MapPin className="h-6 w-6 text-amber-600" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 text-lg">Local Services - Surat</h3>
                <p className="text-gray-600">All AC installation, repair, service and AMC for residential and commercial clients in Surat city.</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-md border border-amber-100">
            <div className="flex items-start gap-4">
              <div className="bg-black p-3 rounded-lg">
                <Building2 className="h-6 w-6 text-amber-400" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 text-lg">Pan India Projects</h3>
                <p className="text-gray-600">VRF Systems and Ductable AC installations for commercial and industrial clients anywhere in India.</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-md border border-amber-100">
            <div className="flex items-start gap-4">
              <div className="bg-green-100 p-3 rounded-lg">
                <Phone className="h-6 w-6 text-green-600" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 text-lg">24/7 Support</h3>
                <p className="text-gray-600">Round-the-clock emergency support and quick response for all your HVAC needs.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreasSection;
